import { useState, useEffect } from 'react';
import {history} from "../index"

const useLocation = () => {

    const [location, setLocation] = useState(history.location.pathname);


    useEffect(() => {
        // Listen for all navigation events.
        const unlisten = history.listen((location) => {
            setLocation(location.pathname);
        });

        return () => {
            unlisten(); // clean up on unmount
        };
    }, []);

    return location;
}

export default useLocation;